import { render, staticRenderFns } from "./rollingBarrage.vue?vue&type=template&id=d2dd16a0&scoped=true"
import script from "./rollingBarrage.vue?vue&type=script&lang=js"
export * from "./rollingBarrage.vue?vue&type=script&lang=js"
import style0 from "./rollingBarrage.vue?vue&type=style&index=0&id=d2dd16a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dd16a0",
  null
  
)

export default component.exports